import { render } from "./WHeader.vue?vue&type=template&id=decaacc2&scoped=true&ts=true"
import script from "./WHeader.vue?vue&type=script&lang=ts"
export * from "./WHeader.vue?vue&type=script&lang=ts"

import "./WHeader.vue?vue&type=style&index=0&id=decaacc2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-decaacc2"]])

export default __exports__